import dotProp from 'dot-prop-immutable'
import { SAVE_HISTORY_CHAT_SUCCESS, LOAD_LIVEDETAIL_SUCCESS, LOAD_REVIEWLIVE_SUCCESS, SUBMIT_REVIEW_SUCCESS, LOAD_CATEGORYCREATOR_SUCCESS } from '../actions/types'
import { token } from '../utils'
const initialState = {
  categoryCreator: [{
    _id: '0',
    displayName: 'ทั้งหมด',
  }],
  historyChat: [],
  product: {
    streamKey: null,
    title: "โลกและดาราศาสตร์",
    streamUrl: null,
    // pdfs: [
    //     {
    //         "fileUrl": "https://s3-ap-southeast-1.amazonaws.com/s3.deknerd.com/pdfs/GAT_deknerd.pdf?fbclid=IwAR2sSqLHIKh2mUsFb_28NbfCOk44DNIzHoE3i4ej3S_Ho6mYWkpiT4G-fUo",
    //         "title": "GAT",
    //         "_id": "5c46ad0b361cb04128a555e4",
    //         "active": 0,
    //         "purchasedDate": 1548135691660,
    //         "fileImage": []
    //     }
    // ],
    pdfs: [],
    recordUrl: null,
    promotional: {
      imageURL: '',
      imageURLShare: '',
      imageURL_1_1: '',
      imageURL_16_9: '',
      urlVideoOut: null,
      videoURL: "",
      active: 0,
    },
    // recordUrl: '',
    // chatKey: "livechat_5c45698387b47312f3020bbf",
    chatKey: "",
    chat: null
  },
  comments: {
    rating: {
      _id: "5c45aec1e3b99e37233dc5b1",
      user: 3,
      avg: 4.5,
      product: "5c45aec1e3b99e37233dc5b5",
      livestream: null,
      examtest: null,
      exam: null,
      course: null
    },
    rating1: 0,
    rating2: 0,
    rating3: 0,
    rating4: 0,
    rating5: 67,
    comments: [],
  },
}
const updateCommented = (state, action) => {
  let newState = null
  
  if(action.payload.idComment !== undefined){
      let parentComment = state.comments.comments.findIndex(commentReply => commentReply._id === action.payload.idComment)
      let oldComment = state
      if(oldComment.comments.comments[parentComment].commentIn === undefined){
        oldComment.comments.comments[parentComment].commentIn = []
      }
      oldComment.comments.comments[parentComment].commentIn.push({
        comment: action.payload.comment,
        commentIn: action.payload.commentIn,
        customer: action.payload.customer,
        date: action.payload.date,
        isMyComment: token === '' ? false : true,
        rating: action.payload.rating,
        idComment: action.payload.idComment,
        _id: action.payload._id,
      })
      newState = dotProp.set(state, 'comments', oldComment.comments)
    //   newState = dotProp.set(state, 'comments', oldComment.comments, {
    //   comment: action.payload.comment,
    //   commentIn: action.payload.commentIn,
    //   customer: action.payload.customer,
    //   date: action.payload.date,
    //   isMyComment: token === '' ? false : true,
    //   rating: action.payload.rating,
    //   _id: action.payload._id,
    // })
  } else {
    newState = dotProp.merge(state, 'comments.comments', {
      comment: action.payload.comment,
      customer: action.payload.customer,
      commentIn: action.payload.commentIn,
      date: action.payload.date,
      isMyComment: token === '' ? false : true,
      rating: action.payload.rating,
      _id: action.payload._id,
    })
  }
  return {
    ...newState,
  }
}

const live = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_HISTORY_CHAT_SUCCESS: {
      if (Array.isArray(action.payload)) {
        return {
          ...state,
          historyChat: action.payload,
        }
      }
      return {
        ...state,
        historyChat: [
          ...state.historyChat,
          action.data,
        ],
      }
    }
    case LOAD_LIVEDETAIL_SUCCESS: {
      return {
        ...state,
        product: action.payload,
        // historyChat: action.payload.chat !== null ? action.payload.chat : [],
      }
    }
    case LOAD_REVIEWLIVE_SUCCESS: {
      return {
        ...state,
        comments: action.payload,
      }
    }
    case LOAD_CATEGORYCREATOR_SUCCESS: {
      return {
        ...state,
        categoryCreator: [
          ...state.categoryCreator,
          ...action.payload,
        ]
      }
    }
    case SUBMIT_REVIEW_SUCCESS: return updateCommented(state, action)
    default:
      return state
  }
}

export default live



// WEBPACK FOOTER //
// ./src/reducers/live.js